import { render, staticRenderFns } from "./OnboardingContractView.vue?vue&type=template&id=1c721f8b&scoped=true"
import script from "./OnboardingContractView.vue?vue&type=script&lang=js"
export * from "./OnboardingContractView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c721f8b",
  null
  
)

export default component.exports